export const DROPDOWN_ITEMS = [
  {
    btnText: "login",
  },
  {
    btnText: "sign up",
    loginOptions: { signUp: true },
  },
];
